'use client';

import type { ImageProps } from 'next/image';
import NextImage from 'next/image';
import config from '@packages/config';
import { useState } from 'react';
import { akamaiLoader } from './loader';

const {
  assets: { assetServerHost, fallbackImageUrl },
} = config;

// TODO: img sizes and akamai settings tbd and custom akamai image loader has to be build
export const getImageSize = (src: ImageProps['src']) => {
  const type = typeof src === 'string' && src?.split('?').pop();
  switch (type) {
    case '$PL_portrait_hq$':
      return { width: 339, height: 485 };
    case '$PL_landscape_hq$':
      return { width: 399, height: 236 };
    case '$PL_square_highlight$':
      return { width: 1000, height: 1000 };
    default:
      // TODO: check what if no case match
      // return { width: 339, height: 485 };
      return undefined;
  }
};

/**
 * Image component based on https://nextjs.org/docs/basic-features/image-optimization
 * */
export const Image = ({
  src,
  width,
  height,
  noLoader = false,
  fallbackSrc = assetServerHost + fallbackImageUrl,
  ...props
}: ImageProps & { noLoader?: boolean; fallbackSrc?: string }) => {
  const [renderFallback, setRenderFallback] = useState(false);

  const imgSrc = renderFallback || !src ? fallbackSrc : src;

  return (
    <NextImage
      src={imgSrc}
      width={props.fill ? undefined : width || getImageSize(imgSrc)?.width}
      height={props.fill ? undefined : height || getImageSize(imgSrc)?.height}
      loader={noLoader ? undefined : akamaiLoader}
      unoptimized={process.env.NODE_ENV === 'test'}
      onError={() => {
        setRenderFallback(true);
      }}
      {...props}
    />
  );
};
